import React, { Component } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  InputGroup,
  Row,
  Col,
  Alert,
} from 'reactstrap';
import Draggable from 'react-draggable';

import { ProviderOfficeForm } from './ProviderOfficeForm';
import { ProviderFormTableDefault } from './ProviderFormTableDefault';

import { FetchData } from './utils/DataFetch';
import { GetCookie, Timeout } from './utils/Common';

import AddIcon from '../images/add.png';

export class ProviderFormSearch extends Component {
  static displayName = ProviderFormSearch.name;

  constructor(props) {
    super(props);

    this.user = JSON.parse(GetCookie('user'));
    this.state = {
      providerList: [],

      modal: false,
      alert: this.props.alert,
      model: {
        EventType: 'insert',
        ProvId: null,
        ProvLastName: '',
        ProvFirstName: '',
        ProvTitle: '',
        ProvSpeciality: '',
        ProvReceptionist: '',
        ProvPhone: '',
        ProvPhone2: '',
        ProvStreet: '',
        ProvCity: '',
        ProvState: '',
        ProvZip: '',
        ProvNote: '',
        ProvIntNote: '',
        ProvInactiveFlg: false,
        CreateByUserId: null,
        CreateDateTime: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        IsDeletedFlg: false,
        DeletionReason: '',
        UserName: '',
      },
      searchModel: {
        FullName: props.Name === null ? '' : props.Name,
      },
      deltaPosition: { x: 0, y: 0 },
    };

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.setModal = this.setModal.bind(this);
    this.resetFields = this.resetFields.bind(this);
    this.handleSaveEventSuccess = this.handleSaveEventSuccess.bind(this);
    this.populateProviderOffice = this.populateProviderOffice.bind(this);
    this.renderProviderTable = this.renderProviderTable.bind(this);

    if (props.Name !== null && props.Name !== '') this.populateProviderOffice();

    this.provSearchRef = React.createRef();
  }

  componentDidMount() {
    this.setState({ isMounted: true }); // Set isMounted to true when the component mounts

    document.addEventListener('keydown', this.keydownHandler);

    // Set focus to the rep name field
    setTimeout(() => {
      if (this.provSearchRef.current) {
        this.provSearchRef.current.focus();
      }
    }, 100);

    return () => {
      document.removeEventListener('keydown', this.keydownHandler);
    };
  }

  onStart = () => {};

  onStop = () => {};

  handleDrag = (e, ui) => {
    const { deltaPosition } = this.state;
    this.setState({
      deltaPosition: {
        x: deltaPosition.x + ui.deltaX,
        y: deltaPosition.y + ui.deltaY,
      },
    });
  };

  async populateProviderOffice() {
    this.props.setFetchingData(true);
    await FetchData(
      '/getprovideroffices',
      'POST',
      this.user.token,
      this.state.searchModel
    ).then((data) => {
      this.setState({ providerList: data, loading: false });
      this.props.setFetchingData(false);
    });
  }

  handleChange(e) {
    let model = { ...this.state.searchModel };
    model[e.target.name] = e.target.value;

    this.setState({ searchModel: model });
  }

  handleKeyDown(e) {
    if (e.key === 'Enter') {
      this.populateProviderOffice();
    }
  }

  handleSaveEventSuccess(alert) {
    this.setState(
      {
        modal: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          // Close the alert so the green background disappears with the message
          this.setState((prevState) => ({
            alert: { ...prevState.alert, isOpen: false },
          }));
        }, Timeout(alert.message));
        this.populateProviderOffice();
      }
    );
  }

  setModal() {
    this.setState({ modal: !this.state.modal });
  }

  resetFields() {
    this.setState((prevState) => ({
      model: {
        EventType: 'insert',
        ProvId: null,
        ProvLastName: '',
        ProvFirstName: '',
        ProvTitle: '',
        ProvSpeciality: '',
        ProvReceptionist: '',
        ProvPhone: '',
        ProvPhone2: '',
        ProvStreet: '',
        ProvCity: '',
        ProvState: '',
        ProvZip: '',
        ProvNote: '',
        ProvIntNote: '',
        ProvInactiveFlg: false,
        CreateByUserId: null,
        CreateDateTime: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        IsDeletedFlg: false,
        DeletionReason: '',
        UserName: '',
      },
    }));

    this.setModal();
  }

  renderProviderTable(providerList) {
    return (
      <ProviderFormTableDefault
        providerList={this.state.providerList}
        handleDoubleClick={this.props.handleDoubleClick}
      ></ProviderFormTableDefault>
    );
  }

  render() {
    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
    const { deltaPosition } = this.state;

    return (
      <Draggable
        handle=".provider-form-search-handle"
        onDrag={this.handleDrag}
        {...dragHandlers}
      >
        <div>
          <Modal
            isOpen={this.props.modal}
            toggle={this.props.setModal}
            style={{
              transform: `translate(${deltaPosition.x}px, ${deltaPosition.y}px)`,
              width: '800px',
              maxHeight: '500px',
            }}
            backdrop="static"
          >
            <ModalHeader className="provider-form-search-handle handle">
              <span style={{ fontSize: '14px' }}>Search Provider</span>
            </ModalHeader>
            <ModalBody>
              <div>
                <Row>
                  <Col style={{ textAlign: 'center' }}>
                    <Alert
                      color={this.state.alert.color}
                      isOpen={this.state.alert.isOpen}
                    >
                      {this.state.alert.message}
                    </Alert>
                  </Col>
                </Row>
                <Row>
                  <Col className="col-12">
                    <InputGroup size="sm">
                      <input
                        name="FullName"
                        type="text"
                        className="form-control form-control-text"
                        value={this.state.searchModel.FullName}
                        onChange={this.handleChange}
                        ref={this.provSearchRef}
                        placeholder="Provider Name (Lastname Firstname)"
                        onKeyDown={this.handleKeyDown}
                      />
                      <Button color="btn" onClick={this.resetFields} size="sm">
                        <img
                          src={AddIcon}
                          style={{ width: '16px', height: '16px' }}
                          alt="Add"
                        />{' '}
                        New
                      </Button>
                    </InputGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>{this.renderProviderTable(this.state.providerList)}</Col>
                </Row>
              </div>
            </ModalBody>
          </Modal>

          {this.state.modal && (
            <ProviderOfficeForm
              model={this.state.model}
              modal={this.state.modal}
              alert={this.state.alert}
              setModal={this.setModal}
              handleSaveEventSuccess={this.handleSaveEventSuccess}
            />
          )}
        </div>
      </Draggable>
    );
  }
}
